import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AaRestatementService } from "./service/aa-restatement.service";
import { RestatementComponent } from './restatement.component';
import { SelectComponent } from './select/select.component';
import { CompleteComponent } from './complete/complete.component';
import { PickListModule } from 'primeng/picklist';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'client/app/shared';

@NgModule({
  declarations: [RestatementComponent, CompleteComponent, SelectComponent],
  providers: [
    AaRestatementService
  ],
  imports: [
    CommonModule,
    PickListModule,
    SharedModule,
    DatePickerModule,
    FormsModule
  ],
})
export class RestatementModule { }